export const White = '#fff';
export const Black = '#292931';
export const Orange = '#f26b34';
export const Gray = '#f4f4f4';
export const MediumGray = '#E2E2E2';
export const DarkGray ='#4c4e5a';
export const Green = '#00b300';
export const Red = '#cc0000';



// WEBPACK FOOTER //
// ./src/utils/styles/theme/colors.style.js